import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react'

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required: an icon-only control is unreadable to a screen reader without it. */
  label: string
  icon: ReactNode
  round?: boolean
  filled?: boolean
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, round = false, filled = false, className = '', type = 'button', ...rest },
  ref,
) {
  const classes = [
    'icon-btn',
    round || filled ? 'icon-btn--round' : '',
    filled ? 'icon-btn--filled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button ref={ref} type={type} className={classes} aria-label={label} title={label} {...rest}>
      {icon}
    </button>
  )
})

export default IconButton
